import { useQuery } from '@tanstack/react-query';

import { configs } from '@hero/configs';

import { getCSEntries } from '../../services';

export function useGetCSEntries({ entryCode, params = {}, options = {} } = {}) {
  const { asc, desc, pageIndex = 1, occasion = '', limit = 200, query } = params;

  return useQuery(
    ['useGetCSEntriesKey', asc, desc, pageIndex, occasion, limit, query, entryCode],
    async () => {
      const response = await getCSEntries(entryCode, {
        skip: (pageIndex - 1) * limit,
        limit,
        asc,
        desc,
        include_count: true,
        query: JSON.stringify({
          ...query,
          'global_field.merchant_code': configs.merchantName
        })
      });

      const hasNextPage = response.count > pageIndex * limit;
      const hasPrevPage = pageIndex > 1;

      return {
        ...response,
        pagination: {
          total: response.count,
          hasNextPage,
          hasPrevPage,
          hasPagination: !!hasNextPage || !!hasPrevPage
        }
      };
    },
    { ...options }
  );
}
